import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

const SEO = ({ 
  title = "Leading Web & App Development Company | Sutrasync 2026",
  description = "Expert web & mobile app developers in India's tech hub. 500+ projects delivered with 98% satisfaction. React Native, Flutter, digital marketing. Free consultation - Call +91 7483961283!",
  keywords = "Sutrasync, SutraSync, web development company, app development services, android app development, iOS app development, React Native, Flutter, modern web development, progressive web apps, responsive website design, digital marketing agency, mobile app development, software development, IT company, web design, digital marketing services, custom software development, React development, Angular development, Vue.js development, Node.js, SEO services, Bengaluru, Karnataka, India",
  image = "https://sutrasync.com/logo.png",
  url = "https://sutrasync.com/",
  type = "website",
  structuredData = null,
  article = null
}) => {
  const siteTitle = title.includes('Sutrasync') ? title : `${title} | Sutrasync`;
  
  // Update document title for better SEO
  useEffect(() => {
    document.title = siteTitle;
    
    // Scroll to top on page change for better UX
    window.scrollTo(0, 0);
    
    // Send page view to analytics
    if (window.gtag) {
      window.gtag('config', 'G-HHM5QL2XHL', {
        page_path: url,
        page_title: siteTitle
      });
    }
  }, [siteTitle, url]);
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="title" content={siteTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />
      <link rel="canonical" href={url} />
      
      {/* Language and Locale */}
      <meta httpEquiv="content-language" content="en" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="Sutrasync" />
      <meta property="og:locale" content="en_US" />
      
      {/* Article specific meta tags */}
      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          <meta property="article:modified_time" content={article.modifiedTime} />
          <meta property="article:author" content={article.author} />
          <meta property="article:section" content={article.section} />
          {article.tags && article.tags.map((tag, index) => (
            <meta key={index} property="article:tag" content={tag} />
          ))}
        </>
      )}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@sutrasync" />
      <meta name="twitter:creator" content="@sutrasync" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:domain" content="sutrasync.com" />
      
      {/* Additional SEO Meta Tags */}
      <meta name="author" content="Sutrasync" />
      <meta name="publisher" content="Sutrasync" />
      <meta name="copyright" content="Sutrasync" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
      <meta name="revisit-after" content="7 days" />
      <meta name="referrer" content="no-referrer-when-downgrade" />
      
      {/* Geo Location Tags */}
      <meta name="geo.region" content="IN-KA" />
      <meta name="geo.placename" content="Bangalore, Karnataka, India" />
      <meta name="geo.position" content="12.9716;77.5946" />
      <meta name="ICBM" content="12.9716, 77.5946" />
      
      {/* Mobile Optimization */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="Sutrasync" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
      
      {/* Breadcrumb Structured Data */}
      {url !== 'https://sutrasync.com/' && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://sutrasync.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": title.split('|')[0].trim(),
                "item": url
              }
            ]
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;